module.exports = __webpack_public_path__ + "img/icon_response_page_info.svg";